import type { FC } from 'react'
import { useMemo } from 'react'

import { cn } from '@/utils'
import { differenceInSeconds } from 'date-fns'

import type { TodDisplayFormat } from '~shared/types'

import type { GroupTiming } from './group.types'
import { GroupRange } from './GroupRange'

type GroupPlannedTimeRangeProps = {
  groupTiming: GroupTiming | null
  timezone?: string | null
  todDisplayFormat?: TodDisplayFormat | null
  className?: string
}

export const GroupPlannedTimeRange: FC<GroupPlannedTimeRangeProps> = ({
  groupTiming,
  timezone,
  todDisplayFormat,
  className,
}) => {
  const isActualNotAsPlanned = useMemo(() => {
    if (!groupTiming) return false

    const startDifference = Math.abs(
      differenceInSeconds(groupTiming.original.start, groupTiming.actual.start),
    )
    const endDifference = Math.abs(
      differenceInSeconds(groupTiming.original.end, groupTiming.actual.end),
    )

    return startDifference > 1 || endDifference > 1
  }, [groupTiming])

  if (!groupTiming) return null

  return (
    <GroupRange
      start={groupTiming.original.start}
      end={groupTiming.original.end}
      timezone={timezone}
      todDisplayFormat={todDisplayFormat}
      className={cn(
        'opacity-50',
        isActualNotAsPlanned && 'line-through',
        className,
      )}
    />
  )
}
